
import { Component, Inject, Prop } from "vue-property-decorator";
import VueI18n from "vue-i18n";
import { TypedVue } from "@/store/types";
import ComparisonRadarChartComponent, { ComparisonAssessmentItem, ComparisonBenchmarkItem } from "@/components/admin/ComparisonComponents/ComparisonRadarChartComponent.vue";

@Component({ components: { ComparisonRadarChartComponent } })
export default class ElraReport8FullPicture extends TypedVue {
  @Inject("$i18n") readonly $i18n!: VueI18n;

  @Prop({ default: () => [] }) radarCandidates!: ComparisonAssessmentItem[];
  @Prop({ default: () => [] }) radarBenchmarks!: ComparisonBenchmarkItem[];
  @Prop({ default: false }) radarShowNames!: boolean;
  @Prop({ default: false }) radarAllowModeSwitch!: boolean;
  @Prop({ default: "competency" }) radarMode!: string;
  @Prop({ default: "" }) radarColorUniqueKey!: string;
  @Prop({ default: false }) radarFourGroup!: boolean;
  @Prop({ default: "" }) theme!: string;
}
